import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";

import FacebookItem from './FacebookItem';

const FacebookItemNewTab = ({ }) => {
  const [currentFBPostItem, setCurrentFBPostItem] = useState(null);
  const navigate = useNavigate();

  const { reviews } = useSelector(
    (state) => state.fuse.reviews
  );

  useEffect(() => {
    // navigate back to reviews tab if reviews redux state is empty (because the page got refreshed)
    if (reviews?.length == 0) {
      navigate(-1);
      return;
    }

    // Retrieve last clicked FB post ID from sessionStorage
    const latestFBPostId = sessionStorage.getItem('latestFBPostId');
    const tempFBItemFiltered = reviews?.filter((item) => item.source == 'META' && item.sourceReviewId == latestFBPostId);

    if (tempFBItemFiltered?.length > 0) {
      setCurrentFBPostItem(tempFBItemFiltered[0]);
    }
  }, [reviews]);

  return (
    <div className="grid grid-cols-1 px-12 pt-12">
      <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
        >
          <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full hover:bg-gray-300 transition-colors duration-200">
            <KeyboardBackspaceIcon className="text-gray-600" />
          </div>
        </button>
      </div>
      {
        currentFBPostItem && (
          <FacebookItem item={currentFBPostItem} isNewTab={true} />
        )
      }
    </div>
  );
};

export default FacebookItemNewTab;
